import React, { useCallback } from "react";
import Table from "../../../components/Table/Table";
import TableBackdrop from "../../../components/Table/TableBackdrop";
import CustomSnackbar from "../../../components/Snackbar/Snackbar";
import FetchData from "./FetchData";
import GetOptions, { GetLimit } from "./GetOptions";
import IsgProfessionalFilters from "./IsgProfessionalFilters";
import IsgProfessionalModal from "./IsgProfessionalModal";
import DeleteModal from "./DeleteModal";
import LimitInfo from "./LimitInfo";

const emptyFilters = {
  documentType: "",
  active: "",
  signaturePinDefined: "",
};

export default function IsgProfessionalsTable() {
  const tableRef = React.useRef();

  const [numOfEntries, setNumOfEntries] = React.useState(0);
  const [columns, setColumns] = React.useState([]);
  const [options, setOptions] = React.useState({});
  const [limit, setLimit] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("info");
  const [backdropLoading, setBackdropLoading] = React.useState(true);
  const [filtersOpen, setFiltersOpen] = React.useState(false);
  const [filterProps, setFilterProps] = React.useState(emptyFilters);
  const [modal, setModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const reloadLimit = useCallback(async () => {
    setLimit(await GetLimit());
  }, []);

  const init = useCallback(async () => {
    setBackdropLoading(true);
    const fetchedOptions = await GetOptions();
    setOptions(fetchedOptions);
    setColumns([
      { title: "No", field: "id" },
      { title: "TC No", field: "tcNo" },
      {
        title: "Belge Tipi",
        field: "documentType",
        lookup: fetchedOptions.documentTypes,
      },
      { title: "Ad", field: "firstName" },
      { title: "Soyad", field: "lastName" },
      { title: "Branş", field: "branch" },
      { title: "Plaka", field: "plate" },
      {
        title: "Aktiflik",
        field: "active",
        lookup: fetchedOptions.activityState,
      },
      {
        title: "E-İmza PIN",
        field: "signaturePinDefined",
        lookup: fetchedOptions.definitionState,
      },
      {
        title: "Medula Parolası",
        field: "medulaPasswordDefined",
        lookup: fetchedOptions.definitionState,
      },
      { title: "Oluşturulma", field: "createdAt" },
      { title: "Güncellenme", field: "updatedAt" },
    ]);
    await reloadLimit();
    setBackdropLoading(false);
  }, [reloadLimit]);

  React.useEffect(() => {
    init();
  }, [init]);

  const clearFilters = () => {
    setFilterProps(emptyFilters);
    tableRef.current && tableRef.current.onQueryChange();
  };

  const handleOpenModal = (rowData) => {
    setSelectedRow(rowData);
    setModal(true);
  };

  const handleOpenDeleteModal = (rowData) => {
    setSelectedRow(rowData);
    setDeleteModal(true);
  };

  const isLive = (user, rowData) => !rowData?.deletedAt;

  return (
    <>
      <TableBackdrop backdropLoading={backdropLoading} />
      <CustomSnackbar
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        snackbarMessage={snackbarMessage}
        severity={severity}
      />
      <IsgProfessionalModal
        modal={modal}
        setModal={setModal}
        row={selectedRow}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        tableRef={tableRef}
        options={options}
        reloadLimit={reloadLimit}
      />
      <DeleteModal
        modal={deleteModal}
        setModal={setDeleteModal}
        row={selectedRow}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        tableRef={tableRef}
        reloadLimit={reloadLimit}
      />
      <div style={{ marginBottom: 10 }}>
        <IsgProfessionalFilters
          options={options}
          tableRef={tableRef}
          filterProps={filterProps}
          filtersOpen={filtersOpen}
          clearFilters={clearFilters}
          setFilterProps={setFilterProps}
          setFiltersOpen={setFiltersOpen}
        />
      </div>
      <Table
        tableName={"OSGB İzleme Servisi Kullanıcıları"}
        authName="osgbIzlemeIsgProfessionals"
        columns={columns}
        tableRef={tableRef}
        filters={filterProps}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        fetchData={FetchData}
        numOfEntries={numOfEntries}
        setNumOfEntries={setNumOfEntries}
        handleOpenModal={handleOpenModal}
        handleOpenDeleteModal={handleOpenDeleteModal}
        isEditable={isLive}
        isDeletable={isLive}
        disableCreate={Boolean(limit && limit.used >= limit.limit)}
        headerComponents={<LimitInfo limit={limit} />}
      />
    </>
  );
}
